import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client'
import { ApolloLink } from 'apollo-link'
import { handle401Link } from './error'
import { redirectOnError } from './redirectOnError'
import { transactionHeaderLink } from './transactionHeader'
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'

// is generated by apollo:schema:generate
import schema from '.temp/graphql/schema.json'
import { forceErrorHeaderLink } from '@/apollo/forceErrorHeader'

// Install the vue plugin
Vue.use(VueApollo)

// Http endpoint
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql'

// Fragment Matcher
// used for sub-type fragemtns, needs the schema data
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: schema.data
})

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  wsEndpoint: null,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  defaultHttpLink: true,

  // Override default cache
  cache: new InMemoryCache({ fragmentMatcher })
}

let apolloProvider = null

export function getProvider () {
  if (apolloProvider) return apolloProvider
  throw new Error('Provider not created yes. Do not access it outsite component')
}

// Call this in the Vue app file
export function createProvider (vueStore, options = {}) {
  if (apolloProvider) return apolloProvider

  const autoLogoutMessage = options.autoLogoutMessage || 'Sie wurden aus Sicherheitsgründen abgemeldet.'
  delete options.autoLogoutMessage

  const restEndpoint = options.restEndpoint || process.env.VUE_APP_API_BASE_URL
  delete options.restEndpoint

  const usedConfig = {
    ...defaultOptions,
    ...{
      // Override default apollo link
      // note: don't override httpLink here, specify httpLink options in the
      // httpLinkOptions property of defaultOptions.
      link: ApolloLink.from([
        handle401Link(vueStore, autoLogoutMessage, restEndpoint),
        transactionHeaderLink(vueStore)
      ].concat((typeof options.errorRedirects === 'undefined' ? [] : [
        redirectOnError(options.errorRedirects)
      ].concat((process.env.NODE_ENV === 'production') ? [] : [
        forceErrorHeaderLink()
      ])))),

      // Override the way the Authorization header is set
      // getAuth: (tokenName) => ...
      getAuth (tokenName) {
        const token = vueStore?.getters?.accessToken
        if (token === null || typeof token === 'undefined') return ''
        return 'Bearer ' + token
      }
    },
    ...options
  }
  // Create apollo client
  const {
    apolloClient,
    wsClient
  } = createApolloClient(usedConfig)
  apolloClient.wsClient = wsClient

  // Create vue apollo provider
  apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        fetchPolicy: 'cache-and-network',
        // errorPolicy ignore passes data and we have to handle errors ourself with
        // an error handler
        errorPolicy: 'ignore'
      }
    }
    // errorHandler (error) {
    //   // eslint-disable-next-line no-consol
    //   console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
    // }
  })

  return apolloProvider
}

// Manually call this when user log in
export async function onLogin (apolloClient, token) {
  try {
    await apolloClient.resetStore()
  } catch (e) {
  }
}

// Manually call this when user log out
export async function onLogout (apolloClient) {
  try {
    await apolloClient.clearStore()
  } catch (e) {
  }
}
